module.exports = __webpack_public_path__ + "static/img/tit1.1fa31394.png";